import { useForm } from "react-hook-form";
import { useEffect } from "react";

export function EmptyMember({ members = [], onSaveClicked }) {
    const { register, handleSubmit, reset } = useForm({
        defaultValues: { memberId: members[0]?.id || "" }
    });

    useEffect(() => {
        if (members.length > 0) {
            reset({ memberId: members[0].id });
        }
    }, [members, reset]);

    if (members.length === 0) {
        return (
            <div style={{ fontSize: '12px', color: '#6b7280', padding: '10px' }}>
                Усі учасники додані
            </div>
        );
    }

    const onSubmit = (data) => {
        onSaveClicked(data);
    };

    return (
        <div style={{ width: '100%', paddingTop: '5px' }}>
            <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', gap: '8px' }}>
                <select
                    {...register('memberId')}
                    style={{
                        flex: 1,
                        padding: '8px',
                        borderRadius: '8px',
                        border: '1px solid #d1d5db',
                        backgroundColor: '#fff',
                        outline: 'none'
                    }}
                >
                    {members.map(member => (
                        <option key={member.id} value={member.id}>
                            {member.nickName}
                        </option>
                    ))}
                </select>
                <button
                    type="submit"
                    style={{
                        backgroundColor: '#4f46e5',
                        color: 'white',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: '14px'
                    }}
                >
                    Додати
                </button>
            </form>
        </div>
    );
}